<template>
  <v-theme-provider class="grey lighten-4">
    <base-section
      id="boards"
      space="40"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <base-section-heading title="Internal Audit" />
            <base-body space="0">
               <v-container fluid>
                <v-row dense>
                    <v-col md="4"
                    xs="12"></v-col>
                  <v-col
                    v-for="card in cards"
                    :key="card.name"
                    md="4"
                    xs="12"
                  >
                    <div 
                    data-aos="zoom-out"
                    data-aos-delay="50"
                    data-aos-duration="1000"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="true"
                    data-aos-anchor-placement="top-center">
                    <v-hover v-slot="{ hover }">
                    <v-card
                    :elevation="hover ? 20 : 0"
                    :class="{ 'on-hover': hover }"
                    outlined>
                      <v-img
                        :src="require(`@/assets/${card.src}`)"
                        class="white--text align-end"
                        height="320px"
                        :gradient="hover ? '' : 'to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)'"
                        :alt="card.name"
                      >
                      <v-card-title class="body-1" v-text="card.name" v-if="hover===false"></v-card-title>
                      </v-img>
                      <v-card-actions>
                        <div  v-if="hover" class="caption" v-html="card.detail"> </div>
                        <div v-else>{{ card.title }}</div>
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                    </div>
                  </v-col>
                  <v-col class="text-center mt-3">
                  <base-btn
                    :block="$vuetify.breakpoint.smAndDown"
                    color="accent"
                    large
                    outlined
                    to="struktur-perusahaan"
                    v-if="$route.name === 'tentang-kami'"
                    class = "text-capitalize"
                  >
                    Struktur Perusahaan
                  </base-btn>
                </v-col>
                </v-row>
              </v-container>
            </base-body>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionBoards',
    data: () => ({
            posts: [],
            cards: [
              { name: 'Ahmad Rahadian', title: 'Internal Audit', src: 'AhmadRahadian-nologo.png', detail: '<strong>Ahmad Rahadian S.E., QRMO., CIAP.</strong> Meraih gelar S1 di Fakultas Ekonomi Universitas Trisakti, Jakarta. Beliau menjabat sebagai Internal Audit PT Asuransi Takaful Umum sejak tahun 2019 dan sebelumnya pernah bekerja dalam bidang Accounting.' },
            ],
        }),
  }
</script>
<style>